import { render, staticRenderFns } from "./projectsDash.vue?vue&type=template&id=bfedff2e&scoped=true"
import script from "./projectsDash.vue?vue&type=script&lang=js"
export * from "./projectsDash.vue?vue&type=script&lang=js"
import style0 from "./projectsDash.vue?vue&type=style&index=0&id=bfedff2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfedff2e",
  null
  
)

export default component.exports